const spearheadLogo =
  "https://images.squarespace-cdn.com/content/v1/643ef4113baeaf1e26fe44f3/8e372ef4-31ff-47bb-84cf-108e1cbeef10/Spearheadlogo.png";

export default spearheadLogo;
